import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { orderBy as _orderBy, sortedUniq as _sortedUniq } from 'lodash-es';
import { API_STATUS, isComplete } from 'store/constants';
import { fetchCategories } from './categoriesAPI';

const initialState = {
	categoriesLoaded: false,
	categoriesList: []
};

// thunk & service
export const getCategoriesAsync = createAsyncThunk('categories/fetchCategories', async () => {
	const categoriesData = await fetchCategories();
	return categoriesData;
});

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: {
		setCategories: (state, action) => {
			// TODO
		}
	},

	extraReducers: builder => {
		builder
			.addCase(getCategoriesAsync.pending, state => {
				state.status = API_STATUS.PENDING;
			})
			.addCase(getCategoriesAsync.rejected, state => {
				state.status = API_STATUS.REJECTED;
			})
			.addCase(getCategoriesAsync.fulfilled, (state, action) => {
				action.payload.forEach(cat => {
					cat.themes = _sortedUniq(cat.themes);
				});
				state.categoriesList = _orderBy(action.payload, ['name'], ['asc']);
				state.categoriesLoaded = true;
				state.status = API_STATUS.COMPLETED;
			});
	}
});

export const selectCategories = state => state.categories.categoriesList.filter(cat => cat.name !== 'All');
export const selectCategoriesWithoutThemes = state => state.categories.categoriesList.map(cat => cat.name);
export const selectCategoriesLoaded = state => isComplete(state.categories.status);
export const selectThemesByName = name => state =>
	state.categories.categoriesList?.find(al => al.name.toLowerCase() === name.toLowerCase())?.themes || ['None'];

export const selectCategoriesTheme = state => categories =>
	state.categories.categoriesList.find(au => au.name === categories)?.themes || ['None'];

export const { setCategories } = categoriesSlice.actions;

export default categoriesSlice.reducer;
